var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { padding: "0 20px", background: "#fff" } },
    [
      _c(
        "a-tabs",
        {
          attrs: { activeKey: _vm.activeKey, destroyInactiveTabPane: "" },
          on: { change: _vm.changeTab },
        },
        [
          _vm._l(_vm.tabList, function (item, index) {
            return _c(
              "a-tab-pane",
              { key: item.key, attrs: { tab: item.tab } },
              [
                _c("SchemeCard", {
                  key: item.key,
                  ref: "schemeCardRef",
                  refInFor: true,
                  attrs: {
                    activeKey: _vm.activeKey,
                    actionUrl: _vm.currTabObj.url,
                    cardType: item.cardType,
                    keysFormArr: _vm.currTabObj.keysFormArr,
                  },
                  on: { cardClick: _vm.schemeCardClick },
                }),
              ],
              1
            )
          }),
          _c(
            "a-button",
            {
              attrs: { slot: "tabBarExtraContent", type: "primary" },
              on: { click: _vm.createLeague },
              slot: "tabBarExtraContent",
            },
            [_vm._v("创建")]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }